module.exports = __webpack_public_path__ + "static/img/QLD-23.da53a11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-23.jpg
// module id = BgNQ
// module chunks = 0